import type { JssStyle } from 'jss';
import type { WebLegacyWidgetEntity } from '@web/types';
import type { MapWidgetData } from '@web/widgets/map/type/map-widget.type';

export function getStyles(widgetData: WebLegacyWidgetEntity<MapWidgetData>): JssStyle {
    return {};
}
